import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import {
  Beneficiary,
  CreateBeneficiaryResponseDTO,
  CreateBeneficiaryRequestDTO,
  EditBeneficiaryRequestDTO,
} from '../entities';
import { EditBeneficiaryRequest, BeneficiaryList } from '../entities';
import { IBeneficiaryRepository } from '../entities/IBeneficiaryRepository';
import { EditBeneficiaryResponseBody } from '../entities/EditBeneficiaryResponseDTO';
import { DeleteBeneficiaryResponseBody } from '../entities/DeleteBeneficiaryResponseDTO';
import { beneficiariesResponseDTOToBeneficiariesAdapter } from './beneficiariesResponseDTOToBeneficiariesAdapter';
import { beneficiaryResponseDTOToBeneficiaryAdapter } from './beneficiaryResponseDTOToBeneficiaryAdapter';

class BeneficiaryRepositoryImpl implements IBeneficiaryRepository {
  constructor() {
    this.GetBeneficiaries = this.GetBeneficiaries.bind(this);
    this.GetBeneficiary = this.GetBeneficiary.bind(this);
    this.CreateBeneficiary = this.CreateBeneficiary.bind(this);
    this.EditBeneficiary = this.EditBeneficiary.bind(this);
    this.DeleteBeneficiary = this.DeleteBeneficiary.bind(this);
  }

  GetBeneficiaries(customerId: number, page: number, perPage: number, all: boolean): Promise<BeneficiaryList> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/users/beneficiaries/${customerId}`,
        params: {
          page,
          perPage,
          all
        },
        dataAdapter: beneficiariesResponseDTOToBeneficiariesAdapter,
      },
    });
  }

  GetBeneficiary(id: number, customerId: number): Promise<Beneficiary> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/users/beneficiaries/${customerId}/${id}`,
        dataAdapter: beneficiaryResponseDTOToBeneficiaryAdapter,
      },
    });
  }

  CreateBeneficiary(
    customerId: number,
    { name, data }: CreateBeneficiaryRequestDTO,
    successCallback: SuccessCallback,
    error: ErrorCallback,
  ): Promise<CreateBeneficiaryResponseDTO> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/users/beneficiaries/${customerId}`,
        data: new CreateBeneficiaryRequestDTO(name, data),
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
        nextCallback: successCallback,
        onErrorCallback: error,
      },
    });
  }

  EditBeneficiary(
    customerId: number,
    id: number,
    { alias, data }: EditBeneficiaryRequest,
    successCallback: SuccessCallback,
  ): Promise<EditBeneficiaryResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: `/secure-web/api/private/users/beneficiaries/${customerId}/${id}`,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
        data: new EditBeneficiaryRequestDTO(alias, data),
        nextCallback: successCallback,
      },
    });
  }

  DeleteBeneficiary({
    customerId,
    beneficiaryId,
    successCallback,
  }: {
    customerId: string;
    beneficiaryId: number;
    successCallback: () => Promise<unknown> | undefined;
  }): Promise<DeleteBeneficiaryResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'DELETE',
        url: `/secure-web/api/private/users/beneficiaries/${customerId}/${beneficiaryId}`,
        nextCallback: successCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }
}

export { BeneficiaryRepositoryImpl };
